import { RouterModule, Routes } from "@angular/router";
import { AuthGuard } from "src/app/core/guard/utility.guard";
import { DigitalIdentityAuthoringToolsComponent } from "./authoring-tools/digital-identity-authoring-tools.component";
import { DigitalIdentityToolsComponent } from "./digital-identity-tools/digital-identity-tools.component";
import { IdentityProvisioningComponent } from "./identity-provisioning/identity-provisioning.component";
import { DashboardComponent } from "./authoring-tools/dashboard/dashboard.component";
import { ImportEmpInfoComponent } from "./identity-provisioning/import-emp-info/import-emp-info.component";
import { AggregateEmpDetailComponent } from "./identity-provisioning/aggregate-emp-detail/aggregate-emp-detail.component";
import { AssignDigitalIdComponent } from "./identity-provisioning/assign-digital-id/assign-digital-id.component";
import { IdentityAdminPanelComponent } from "./identity-admin-panel/identity-admin-panel.component";
import { AuditTrailAuthComponent } from "./audit-trail-auth/audit-trail-auth.component";
import { TerminationAuditDetailsComponent } from "./audit-trail-auth/termination-audit-details/termination-audit-details.component";
import { TransferAuditDetailsComponent } from "./audit-trail-auth/transfer-audit-details/transfer-audit-details.component";
import { TransferEmpComponent } from "./identity-admin-panel/transfer-emp/transfer-emp.component";
import { TransferOrgUnitComponent } from "./identity-admin-panel/transfer-org-unit/transfer-org-unit.component";
import { ReportsComponent } from "./reports/reports.component";
import { DigitalIdentityDashboardDataResolver } from "src/app/core/resolvers/digital-identity/dashboard-data.resolver";

export const digitalIdentityRoutes: Routes =[
    {
        path: 'digital-identity/auth-tools',

        component: DigitalIdentityAuthoringToolsComponent,
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        children: [
 
      {path:'identity-provisioning', component:IdentityProvisioningComponent},
      {path:'identity-admin-panel', component:IdentityAdminPanelComponent},
      {path:'identity-admin-panel/transferemp/:digitalId/:organization/:organizationUnit/:organizationId', component:TransferEmpComponent},
      {path:'identity-admin-panel/transferorganizationunit', component:TransferOrgUnitComponent},
      {path:'identity-provisioning/import-emp-info', component:ImportEmpInfoComponent},
      {path:'identity-provisioning/aggregate-emp-details/:organizationName/:organizationUnit', component:AggregateEmpDetailComponent},
      {path:'identity-provisioning/assign-digital-id', component:AssignDigitalIdComponent},
      {path: 'audit-trail-auth', component: AuditTrailAuthComponent},
      {path: 'audit-trail-auth/termination-view', component: TerminationAuditDetailsComponent},
      {path: 'audit-trail-auth/transfer-view', component: TransferAuditDetailsComponent},
       {path:'digital-identity-reports', component:ReportsComponent},
      {path:'', component:DashboardComponent,resolve: { dashboard: DigitalIdentityDashboardDataResolver }},

    ],
      },
      
       {path: 'digital-identity/auth-tools', component: DigitalIdentityAuthoringToolsComponent, canActivate:[AuthGuard]}, 
       {path: 'digital-identity/tools',component:DigitalIdentityToolsComponent}
    

  ];

   export const digitalIdentityRouter = RouterModule.forChild(digitalIdentityRoutes);